import { createDAppKit } from '@mysten/dapp-kit-react'
import { createSuiClient, parseRpcUrls } from '@kunalabs-io/kai'
import { registerSuiSnapWallet } from '@kunalabs-io/sui-snap-wallet'

// Register the MetaMask Sui Snap as a Wallet Standard wallet before the dApp Kit
// instance enumerates wallets, so it shows up in the wallet list on first load.
registerSuiSnapWallet()

export const dAppKit = createDAppKit({
  networks: ['mainnet'],
  defaultNetwork: 'mainnet',
  createClient(network) {
    // VITE_KAI_RPC_URL may be a comma-separated, priority-ordered list; unset
    // falls back to the SDK defaults (kunalabs node, then public fullnode).
    return createSuiClient({
      network,
      urls: import.meta.env.VITE_KAI_RPC_URL
        ? parseRpcUrls(import.meta.env.VITE_KAI_RPC_URL)
        : undefined,
      onFailover: e => console.warn('rpc failover', e.url, '->', e.nextUrl, e.method),
    })
  },
  autoConnect: true,
  slushWalletConfig: { appName: 'Kai Finance' },
})

// Global type registration so the hooks (useCurrentClient, useDAppKit, ...) infer
// our network list and the concrete SuiGrpcClient type.
declare module '@mysten/dapp-kit-react' {
  interface Register {
    dAppKit: typeof dAppKit
  }
}
